const LOG_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
};

module.exports = { LOG_STATUS };
